import { LayerModule } from './.LayerModule.js';
import ApiLayersMap from '../WebApiModules/ApiLayersMap.js';

export class VectorTileLayerModule extends LayerModule {
    async OpenLayer(callback) {
        return new Promise((rs) => {
            ApiLayersMap.ListLayerInfo(
                { FolderFullName: this.layerInfo.FolderFullName, Name: this.layerInfo.Name },
                (obj) => {
                    console.log(obj);
                    let result = obj.result;
                    let url = result.URL || `${window.gMainMap.OviewMapServerUrlUnderProxy()}/3857/${result.ID}/{z}/{x}/{y}.vector.mvt`
                    console.log(url);
                    this.oviewLayer = window.gMainMap.TerrainView.addTerrainVectorTileOverlay({
                        url: url,
                        urlTemplate: result.URLTemplate || window.gMainMap.ProxyUrlTemplete(),
                        layername: result.Name,
                        lineWidth: 5,
                        minLevel: 0,
                        maxLevel: 18,
                        opacity: 1.0,
                        visibleFactor: 20.0,
                        isGeoJson: false,
                        pointSetting: {
                            textLabel: result.TextLabel,
                            fadeEffect: true,
                            allowOverlapping: false,
                            groundLineColor: new window.ov.Color("#FF0000"),
                            fontTable: {
                                "DEFAULT": {
                                    font: "標楷體",
                                    fontSize: 16,
                                    fontColor: new window.ov.Color("#000000"),
                                    fontBorderSize: 1,
                                    fontBorderColor: "#ffff00",
                                    pullUpY: 100,
                                },
                            }
                        },
                        polylineSetting: {
                            colorTable: {
                                "DEFAULT": {
                                    color: "#e0e0e080"
                                },
                            }
                        },
                        polygonSetting: {
                            //colorLabel: "show_color_label",
                            colorTable: {
                                "DEFAULT": {
                                    fillColor: "#FF0000",
                                    boundaryColor: "#00FF00",
                                    boundaryWidth: 2
                                }
                            }
                        }
                    }, rs);
                },
                () => {
                    console.error(`取得${this.layerInfo.FolderFullName}/${this.layerInfo.Name}圖層資訊失敗`)
                }
            )
        }).then((param) => {
            console.log(param);
            console.log(this.oviewLayer);
            if (param.message === "duplicate name exists") { // 如果只是名稱重複當作成功
                this.oviewLayer = window.gMainMap.TerrainView.getTerrainOverlay(this.layerInfo.Name);
                param.success = true;
            }
            // 有參考的圖層到都加進去
            window.gMainMap.TerrainView.openedLayerStack.push(this.oviewLayer.layername);
            callback && callback(param);
            return param.success;
        }, () => {
            return false;
        });
    }
}